const Environment = {
    isDevelopment(): boolean {
        return process.env.NODE_ENV === 'development';
    },
    isProduction(): boolean {
        return process.env.NODE_ENV === 'production';
    },
    /** Cursor Preview / local webpack only — never true on DEV or production hosting. */
    isLocalPreviewHost(): boolean {
        if (typeof window === 'undefined') {
            return false;
        }
        const host = window.location.hostname;
        return host === '127.0.0.1' || host === 'localhost' || host === '[::1]';
    },
    get supportsPositiveLookBehindInRegexp(): boolean {
        let res = false;
        try {
            res = ('test'.search(RegExp('(?<=(t))est')) === 1);
        } catch {
            return false;
        }
        return res;
    }
};

export {Environment};
